import { Box, Avatar } from "@mui/joy";
import { ExitToAppIcon } from "../../../styles/StyledMUI";
import { ctaAccentColor, textTokens } from "../../../styles/globalStyles";

type UserHeaderProps = {
  onLogout: () => void;
};

export default function UserHeader({ onLogout }: UserHeaderProps) {
  return (
    <Box
      sx={{
        position: "absolute",
        top: 12,
        right: 12,
        zIndex: 2,
        display: "flex",
        alignItems: "center",
      }}
    >
      <Avatar
        sx={{
          bgcolor: ctaAccentColor,
          color: textTokens.color.inverse,
          width: 44,
          height: 44,
          cursor: "pointer",
        }}
        onClick={onLogout}
        aria-label="Se déconnecter"
      >
        <ExitToAppIcon />
      </Avatar>
    </Box>
  );
}
